<template>
  <el-dialog title="编辑客服资料" :visible.sync="dialogVisible" @close='dialogFormVisible' :close-on-click-modal="false"
             :close-on-press-escape="false">
      <el-form size="small" :model="form">
                
          <el-form-item label="照片：" prop="avatarUrl"  :label-width="formLabelWidth">
          <div class="draggable-list">
              <div v-if="form.avatarUrl">
                  <div class="item">
                      <img v-img-url="form.avatarUrl" alt="file_path"/>
                      </div>
                  </div>
              <div class="item img-select" @click="openProductUpload('avatarUrl')">
              <i class="el-icon-plus"></i>
              </div>
          </div>
          </el-form-item>
      


          <el-form-item label="姓名" :label-width="formLabelWidth">
              <el-input v-model="form.nickName" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="手机号" :label-width="formLabelWidth">
              <el-input v-model="form.mobile" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="邮箱" :label-width="formLabelWidth">
              <el-input v-model="form.email" autocomplete="off"></el-input>
          </el-form-item>

          <el-form-item label="性别" prop="gender"  :label-width="formLabelWidth">
              <el-radio-group v-model="form.gender">
              <el-radio :label="1">男</el-radio>
              <el-radio :label="0">女</el-radio>
              </el-radio-group>
          </el-form-item>


          <el-form-item label="密码" :label-width="formLabelWidth">
              <el-input v-model="password_val" autocomplete="off" type="password" placeholder="不输入则不修改密码"></el-input>
          </el-form-item>
          <el-form-item label="确认密码" :label-width="formLabelWidth">
              <el-input v-model="password_val2" autocomplete="off" type="password" placeholder="请确认新密码"></el-input>
          </el-form-item>





      </el-form>
      <div slot="footer" class="dialog-footer">
          <el-button @click="dialogFormVisible">取 消</el-button>
          <el-button type="primary" @click="editUser" :loading="loading">确 定</el-button>
      </div>

      <Upload v-if="isProductUpload" :config="{ total: 9 }" :isupload="isProductUpload" @returnImgs="returnProductImgsFunc">上传图片
      </Upload>
  </el-dialog>
</template>

<script>
  import UserApi from '@/api/user.js';
  import Upload from '@/components/file/Upload';

  export default {
      components: {

          Upload: Upload,
      },
      data() {
          return {
              /*左边长度*/
              formLabelWidth: '120px',
              /*是否显示*/
              loading: false,
              dialogVisible: false,
              /* 城市锁 */
              lock_city:true,
              /* 区域锁 */
              lock_region:true,
              province_options:{},
              city_options:{},
              region_options:{},
              password_val:'',
              password_val2:'',
              // 客服到期时间选择器左侧快捷选项
              timePickerOpt: {
              shortcuts: [{
                text: '一年',
                onClick(picker) {
                  const date = new Date()
                  date.setFullYear(date.getFullYear() + 1)
                  picker.$emit('pick', date)
                }
              }, {
                text: '两年',
                onClick(picker) {
                  const date = new Date()
                  date.setFullYear(date.getFullYear() + 2)
                  picker.$emit('pick', date)
                }
              }, {
                text: '三年',
                onClick(picker) {
                  const date = new Date()
                  date.setFullYear(date.getFullYear() + 3)
                  picker.$emit('pick', date)
                }
              }]
            },
            isProductUpload:false,
          };
      },
      props: ['open_kmd','form'],
      created() {
          console.log(this.form)
          this.dialogVisible = this.$parent.open_kmd;
          this.getAddressList();
          this.getCustomer();
          this.getRole();
      },
      methods: {
                 /*打开上传图片*/
     openProductUpload: function (code) {
    this.isProductUpload = true;
    this.code = code
  },
       /*选择的地址*/
       choseFunc(e){
              console.log("触发了吗",e)
              this.form.coordinate=e.location.lat+','+e.location.lng;
              this.form.address=e.address;
              this.$forceUpdate();
          },
          /*获取经纬度*/
          getMapdataFunc(e) {
              this.form.coordinate = e.data[0].toFixed(6) + ',' + e.data[1].toFixed(6);
              this.$forceUpdate();
          },   

  /*上传商品图片*/
 returnProductImgsFunc(e) {

      if (e != null) {
      let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
      let prevent = false;
      console.log(typeof imgExpt);
      e.forEach((element) => {
        let data_array = element.file_path.split(".");
        let ext = data_array[data_array.length - 1];
        imgExpt.forEach((e) => {
          if (e === ext) {
            prevent = true
            return false
          }
        });
      });

      if (!prevent) {
        this.$message.error("图片类型有误,请选择正确的图片格式");
        return false;
      }

        var avatarUrl = e[0].file_path;
        this.form.avatarUrl = avatarUrl;
        this.$set(this.form, "avatarUrl", avatarUrl);
    }
 
    
    this.isProductUpload = false;
  },

          getRole(){
              let self = this

              let Params = {}

              UserApi.getRole(Params, true)
                  .then(data => {
                  self.rolearr = data.data
                  })
                  .catch(error => {

                  });
          },
          getCustomer(){
              let self = this;
              let Params = {}
              Params.user_id = self.form.user_id
              console.log(Params)
              UserApi.getCustomerData(Params,true)
                  .then(data => {
                      console.log(data)
                      self.loading = false;
                      let formInline = data.data.list;
                      if (formInline.province_id > 0){
                          self.lock_city = false
                          self.form.province_name = formInline.province_name
                          self.form.province_id = formInline.province_id
                          self.cityList(formInline.province_id)
                      }
                    //  self.cityList(formInline.province_id)
                      if (formInline.city_id > 0){
                          self.lock_region = false
                          self.form.city_name = formInline.city_name
                          self.form.city_id = formInline.city_id
                          self.form.region_name = formInline.region_name
                          self.form.region_id = formInline.region_id
                          self.regionList(formInline.city_id);
                      }
                  })
                  .catch(error => {
                      self.loading = false;
                  });
          },
          /* 省份获取 */
          getAddressList(){
              let self = this;
              UserApi.provinceList('',true)
                  .then(data => {
                      self.province_options = data.data.list;
                      console.log(self.province_options)
                  })
                  .catch(error => {

                  });
          },
          /* 市列表 */
          cityList(id){
              let self = this;
              let Params = {}
              Params.province_id = id
              UserApi.city_list(Params,true)
                  .then(data => {
                      self.city_options = data.data.list
                  })
                  .catch(error =>{

                  });
          },
          /* 区列表 */
          regionList(id){
              let self = this;
              let Params = {}
              Params.region_id = id
              UserApi.region_list(Params,true)
                  .then(data => {
                      console.log(data)
                      self.region_options = data.data.list
                  })
                  .catch(error =>{

                  });
          },
          /* 选择省 */
          provinceChange(selVal){
              let self = this
              self.form.province_name = selVal.name
              self.form. province_id = selVal.id
              self.form.city_name = ""
              self.form.city_id = ""
              self.form.region_id = ""
              console.log(self.lock_city)
              self.lock_city = false
              console.log(self.lock_city)
              if (!self.lock_region){
                  self.lock_region = true
                  self.form.region_name = ""
              }
              self.cityList(selVal.id)
          },
          /* 选择市 */
          cityChange(selVal){
              let self = this
              self.form.city_name = selVal.name
              self.form.city_id = selVal.id
              self.form.region_name = ""
              self.form.region_id = ""
              if (self.lock_region){
                  self.lock_region = false
              }
              self.regionList(selVal.id);
          },
          /* 选择区 */
          regionChange(selVal){
              let self = this
              self.form.region_name = selVal.name
              self.form.region_id = selVal.id
              /* 层级太深，需要手动刷新渲染 */
              self.$forceUpdate();
              console.log(self.form.region_name)
          },


          editUser(){
              let self = this;
              self.loading = true;
              let params = self.form;
              if(self.password_val != ''){
                  if(self.password_val2 == ''){
                      self.$message({
                          message: '请确认新密码',
                          type: 'info'
                      });
                      self.loading = false;
                      return false;
                  }

                  if(self.password_val != self.password_val2){
                      self.$message({
                          message: '密码不一致',
                          type: 'info'
                      });
                      self.loading = false;
                      return false;
                  }

                  params.password = self.password_val
              }

              // 地区信息完善
              //用户地区信息改为非必填
              // if (params.city_id == undefined || params.city_id == ''){
              //     self.$message({
              //         message: '请完善用户地区信息',
              //         type: 'info'
              //     });
              //     self.loading = false;
              //     return false;
              // }
              // if (params.region_id == undefined || params.region_id == ''){
              //     self.$message({
              //         message: '请完善用户地区信息',
              //         type: 'info'
              //     });
              //     self.loading = false;
              //     return false;
              // }
              UserApi.editAdd(params,true)
                  .then(data => {
                      self.loading = false;
                      if (data.code == 1) {
                          self.$message({
                              message: '恭喜你，用户修改成功',
                              type: 'success'
                          });
                          self.dialogFormVisible(true);
                      }
                  })
                  .catch(error => {
                      self.loading = false;
                  });
          },
          /*关闭弹窗*/
          dialogFormVisible(e) {
              if (e) {
                  this.$emit('closeDialog', {
                      type: 'success',
                      openDialog: false
                  })
              } else {
                  this.$emit('closeDialog', {
                      type: 'error',
                      openDialog: false
                  })
              }
          }
      }
  }
</script>

<style scoped >
  .draggable-list {
display: flex;
justify-content: flex-start;
align-items: center;
flex-wrap: wrap;
}

.draggable-list .wrapper > span {
display: flex;
justify-content: flex-start;
flex-wrap: wrap;
}

.draggable-list .item {
position: relative;
width: 110px;
height: 110px;
margin-top: 10px;
margin-right: 10px;
border-radius: 8px;
overflow: hidden;
border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
position: absolute;
top: 0;
right: 0;
width: 16px;
height: 16px;
background: red;
line-height: 16px;
font-size: 16px;
color: #ffffff;
display: none;
}

.draggable-list .item:hover .delete-btn {
display: block;
}

.draggable-list .item img {
position: absolute;
top: 50%;
left: 50%;
-webkit-transform: translate(-50%, -50%);
transform: translate(-50%, -50%);
max-height: 100%;
max-width: 100%;
}

.draggable-list .img-select {
display: flex;
justify-content: center;
align-items: center;
border: 1px dashed #dddddd;
font-size: 30px;
}

.draggable-list .img-select i {
color: #409eff;
}

</style>



// WEBPACK FOOTER //
// src/views/service/index/part/edit.vue